'use strict';

var dictionary = {
  E: 'ED',
  T: 'TD',
  D: 'DD',
  P: 'PS'
};

module.exports = function (key) {
  return dictionary[key];
};
